import React from 'react'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody, Row } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ValidDates } from '@/components/changeRequests/common/validDates'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'

function ExperienceDialog (props) {
  return (
    <FormLoader {...props} render={() =>
      <ValidationBoundary>
        <BasicHeader title='Individuals.Experience' {...props} />
        <ModalBody>
          <Row>
            <div className='col-12'>
              <FormRow label='Common.Type' name='experienceType' inputType='lookup' dataSource={context.cache.getExperienceTypes} clientSide isCodeList required />
              <FormRow label='Common.Description' name='description' inputType='textarea' required />
              <ValidDates fromName='dateFrom' toName='dateTo' fromKey='Individuals.DateFrom' toKey='Individuals.DateTo' />
            </div>
          </Row>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

export default {
  component: ExperienceDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/experience.js